import publicUrls from "../../routes/publicUrls";
import React, { useCallback, useEffect, useState } from "react";
import "./product.css";
import { getPrivateSingleData, postInequired } from "../../Model/SinglePage";
import { useParams, useNavigate } from "react-router-dom";
import { useMediaQuery, Backdrop, CircularProgress, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, Grid, Typography, useTheme, IconButton, Box, Snackbar, Slide } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { decodeId } from "../../hash";
import PrivateSaleSEO from "../../components/SEO/PrivateSaleSEO";
// --- ANIMATION PARA SA MODAL ---
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// --- PAGE STYLE (display only) ---
const FONT = '"Bell MT", "Times New Roman", serif';
const C = {
  ink: "#111111", // headings, buttons
  text: "#333333", // body copy
  muted: "#666666", // secondary copy
  faint: "#8a8a8a", // small labels
  line: "#e6e6e6", // hairlines
  wall: "#f6f6f4", // artwork backdrop
  paper: "#ffffff",
};
const labelSx = {
  fontFamily: FONT,
  fontSize: "0.75rem",
  fontWeight: 400,
  letterSpacing: "0.18em",
  textTransform: "uppercase",
  color: C.faint,
  lineHeight: 1.5,
};
const fieldLabelSx = { ...labelSx, fontSize: "0.6875rem", color: C.ink, mb: 0.75 };

// --- CUSTOM INPUT STYLE ---
const sothebyInputStyleCompact = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 0,
    fontFamily: FONT,
    fontSize: "1rem",
    backgroundColor: "#fff",
    "& fieldset": { borderColor: "#d9d9d9" },
    "&:hover fieldset": { borderColor: "#111" },
    "&.Mui-focused fieldset": { borderColor: "#111", borderWidth: "1px" },
  },
  "& .MuiInputBase-input": { padding: "11px 12px" },
  mb: 1.5,
};

function View() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg")); // Maintained for sidebar sticky
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("md")); // Used for layout switching
  const { id, group, titles } = useParams();


  // --- STATES ---
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [artist, setArtist] = useState("");
  const [size, setSize] = useState("");
  const [medium, setMedium] = useState("");
  const [signedDated, setSignDate] = useState("");
  const [property, setProperty] = useState("");
  
  const [coa, setCoa] = useState("");
  const [provenance, setProvinance] = useState("");
  const [exhibited, setExhibited] = useState("");
  const [literature, setLiterature] = useState("");
  const [write_up, setWriteUp] = useState("");
  const [selectedImage, setSelectedImage] = useState("");
  const [lot_group, setGroup] = useState(0);
  const [scrollPosition, setScrollPosition] = useState(0);

  const [open, setOpen] = useState(false); // Inquiry Modal
  const [openDetailsModal, setOpenDetailsModal] = useState(false); // Details Fullscreen Modal
  const [openNotif, setOpenNotif] = useState(false);
  const [inquireMessage, setInquireMessage] = useState("");

  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const handleClose = () => setOpen(false);
  const handleClosess = () => setOpenNotif(false);

  const FetchData = useCallback(async () => {
    setLoading(true);
    try {
      const results = await getPrivateSingleData(id);
      if (results && results.length) {
        const row = results[0];
        setGroup(row.data.lot_group);
        setTitle(row.data.title);
        setArtist(row.data.artist);
        setSize(row.data.size);
        setMedium(row.data.medium);
        setCoa(row.data.coa);
        setProperty(row.data.property);
        setSignDate(row.data.signed_dated);
        setProvinance(row.data.provenance);
        setExhibited(row.data.exhibited);
        setLiterature(row.data.literature);
        setWriteUp(row.data.write_up);
        setSelectedImage(row.image[0].img_url);
      }
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  }, [id]);

  useEffect(() => {
    FetchData();
  }, [FetchData]);

  useEffect(() => {
    const handleScroll = () => setScrollPosition(window.pageYOffset);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  async function inquirehandle(event) {
    event.preventDefault();
    setLoading(true);
    try {
      const results = await postInequired({
        firstname,
        lastname,
        email_address: email,
        phone_number: phone,
        message,
        id:decodeId(id),
      });
      setInquireMessage(results.msg);
      setOpen(false);
      setOpenNotif(true);
    } catch (error) {
      setInquireMessage("Error sending inquiry.");
    }
    setLoading(false);
  }

  // --- REUSABLE DETAILS RENDERER ---
  const renderDetailsContent = () => {
    const details = [
      { label: "Certificate of Authenticity", value: coa, italic: true },
      { label: "Provenance", value: provenance },
      { label: "Exhibited", value: exhibited },
      { label: "Literature", value: literature },
      { label: "Write-Up", value: write_up },
    ];

    return details.map(
      (item, index) =>
        item.value &&
        item.value !== "null" && (
          <Box
            key={index}
            component="section"
            sx={{
              borderTop: `1px solid ${C.line}`,
              py: { xs: 3, md: 3.5 },
              "&:last-of-type": { borderBottom: `1px solid ${C.line}` },
            }}
          >
            <Typography component="h3" sx={{ ...labelSx, color: C.ink, mb: 1.5 }}>
              {item.label}
            </Typography>
            <Typography
              component="div"
              sx={{
                fontFamily: FONT,
                color: C.text,
                lineHeight: 1.8,
                fontSize: { xs: "1rem", md: "1.0625rem" },
                textAlign: "left",
                fontStyle: item.italic ? "italic" : "normal",
                "& p": { m: 0, mb: 1.5 },
                "& p:last-child": { mb: 0 },
              }}
              dangerouslySetInnerHTML={{ __html: item.value }}
            />
          </Box>
        )
    );
  };

  const hasContent = (value) =>
  value !== null && value !== undefined && value.toString().trim() !== "";

  const hasDetails =
    hasContent(coa) ||
    hasContent(provenance) ||
    hasContent(exhibited) ||
    hasContent(literature) ||
    hasContent(write_up);

  const contactLinkStyle = {
    color: C.ink,
    textDecoration: "none",
    borderBottom: `1px solid ${C.ink}`,
    paddingBottom: "1px",
  };

  const socialSx = {
    color: C.ink,
    borderRadius: 0,
    width: 34,
    height: 34,
    "&:hover": { bgcolor: "transparent", opacity: 0.55 },
  };

  const seoDescription = [write_up, literature, exhibited, provenance, medium, size, property]
    .filter(Boolean)
    .join(" ");

  return (
    <>
      <PrivateSaleSEO
        title={title}
        artist={artist}
        description={seoDescription}
        image={selectedImage}
        canonical={publicUrls.privateSale(group, id, title || titles || "")}
      />
      <Box className="lg-private-lot" sx={{ bgcolor: C.paper, px: { xs: 2, md: 4 }, pt: { xs: 3, md: 5 }, pb: { xs: 8, md: 12 } }}>
      <div className="container">
        {/* BREADCRUMB */}
        <nav aria-label="breadcrumb" style={{ margin: "0 0 28px 0", background: "transparent" }}>
          <ol
            className="breadcrumb"
            style={{
              display: "flex",
              alignItems: "center",
              listStyle: "none",
              margin: 0,
              padding: 0,
              flexWrap: "nowrap",
              overflowX: "auto",
              scrollbarWidth: "none",
              whiteSpace: "nowrap",
              background: "transparent",
            }}
          >
            <style>{`ol.breadcrumb::-webkit-scrollbar { display: none; }`}</style>
            <li style={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
              <a href="/home" className="lg-private-lot__crumb">HOME</a>
              <span style={{ margin: "0 10px", color: "#c4c4c4" }}>/</span>
            </li>
            <li style={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
              <a
                href={
                  group === "EXHIBITION"
                    ? publicUrls.exhibitions()
                    : publicUrls.privateSales(lot_group)
                }
                className="lg-private-lot__crumb"
              >
                {group === "EXHIBITION" ? "EXHIBITION" : "PRIVATE SALE"}
              </a>
              <span style={{ margin: "0 10px", color: "#c4c4c4" }}>/</span>
            </li>
            <li style={{ minWidth: 0 }}>
              <div className="lg-private-lot__crumb lg-private-lot__crumb--current">{titles}</div>
            </li>
          </ol>
        </nav>

        <Grid container columnSpacing={{ lg: 8 }} rowSpacing={{ xs: 4, lg: 0 }}>
          {/* LEFT — artwork (main scrolling area) */}
          <Grid item xs={12} lg={7}>
            <Box
              sx={{
                height: { xs: 360, sm: 480, md: 640, lg: 720 },
                bgcolor: C.wall,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden",
                p: { xs: 2.5, sm: 4, md: 6 },
                boxSizing: "border-box",
              }}
            >
              <img
                src={selectedImage}
                alt={title}
                style={{
                  maxHeight: "100%",
                  maxWidth: "100%",
                  objectFit: "contain",
                  display: "block",
                }}
              />
            </Box>

            {/* Catalogue details under the artwork (tablet / desktop) */}
            {isLargeScreen && hasDetails && (
              <Box sx={{ mt: { md: 7, lg: 9 }, maxWidth: 760 }}>
                {renderDetailsContent()}
              </Box>
            )}
          </Grid>

          {/* RIGHT — lot information (stays in view while the artwork scrolls) */}
          <Grid item xs={12} lg={5}>
            <Box
              component="aside"
              aria-label="Lot information"
              sx={{
                position:
                  isDesktop && scrollPosition > 150 ? "sticky" : "relative",
                top: isDesktop && scrollPosition > 150 ? 100 : 0,
                pt: { lg: 1 },
              }}
            >
              {property && (
                <Typography
                  component="div"
                  sx={{
                    ...labelSx,
                    color: C.muted,
                    mb: 2.5,
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    lineHeight: 1.6,
                  }}
                  dangerouslySetInnerHTML={{ __html: property }}
                />
              )}

              {/* Artist */}
              <Typography
                component="div"
                role="heading"
                aria-level={1}
                sx={{
                  fontFamily: FONT,
                  fontWeight: 400,
                  color: C.ink,
                  fontSize: { xs: "1.75rem", md: "2.25rem", lg: "2.5rem" },
                  lineHeight: 1.12,
                  letterSpacing: "0.005em",
                }}
                dangerouslySetInnerHTML={{ __html: artist }}
              />

              {/* Title */}
              <Typography
                component="div"
                role="heading"
                aria-level={2}
                sx={{
                  fontFamily: FONT,
                  fontStyle: "italic",
                  fontWeight: 400,
                  color: "#444",
                  mt: 1.25,
                  fontSize: { xs: "1.2rem", md: "1.4rem", lg: "1.5rem" },
                  lineHeight: 1.3,
                }}
                dangerouslySetInnerHTML={{ __html: title }}
              />

              {/* Signed / dated, medium, size */}
              {(hasContent(signedDated) || hasContent(medium) || hasContent(size)) && (
                <Box sx={{ mt: { xs: 3, md: 3.5 }, pt: { xs: 3, md: 3.5 }, borderTop: `1px solid ${C.line}` }}>
                  {[signedDated, medium, size].map(
                    (value, index) =>
                      hasContent(value) && (
                        <Typography
                          key={index}
                          component="div"
                          sx={{
                            fontFamily: FONT,
                            fontSize: { xs: "1rem", md: "1.0625rem" },
                            color: C.text,
                            lineHeight: 1.6,
                            "& + &": { mt: 0.75 },
                            "& p": { m: 0 },
                          }}
                          dangerouslySetInnerHTML={{ __html: value }}
                        />
                      )
                  )}
                </Box>
              )}

              {/* Phones: catalogue details open in a full-screen sheet */}
              {!isLargeScreen && hasDetails && (
                <Button
                  onClick={() => setOpenDetailsModal(true)}
                  disableRipple
                  sx={{
                    ...labelSx,
                    color: C.ink,
                    p: 0,
                    mt: 2.5,
                    minWidth: 0,
                    borderRadius: 0,
                    borderBottom: `1px solid ${C.ink}`,
                    "&:hover": { bgcolor: "transparent", opacity: 0.6 },
                  }}
                >
                  View Details
                </Button>
              )}

              {/* Price + enquiry */}
              <Box sx={{ mt: { xs: 3.5, md: 4 }, pt: { xs: 3, md: 3.5 }, borderTop: `1px solid ${C.line}` }}>
                <Typography sx={{ ...labelSx, mb: 0.75 }}>Price</Typography>
                <Typography
                  sx={{
                    fontFamily: FONT,
                    fontSize: { xs: "1.2rem", md: "1.3rem" },
                    color: C.ink,
                    lineHeight: 1.35,
                  }}
                >
                  Price Available Upon Request
                </Typography>

                {group !== "EXHIBITION" && (
                  <Button
                    onClick={() => setOpen(true)}
                    fullWidth
                    variant="contained"
                    disableElevation
                    sx={{
                      mt: 3,
                      minHeight: 54,
                      bgcolor: C.ink,
                      color: "#fff",
                      borderRadius: 0,
                      fontFamily: FONT,
                      fontSize: "0.875rem",
                      fontWeight: 400,
                      letterSpacing: "0.24em",
                      boxShadow: "none",
                      "&:hover": { bgcolor: "#000", boxShadow: "none" },
                    }}
                  >
                    INQUIRE
                  </Button>
                )}
              </Box>

              {/* Contact */}
              <Box sx={{ mt: { xs: 4, md: 5 }, pt: 3, borderTop: `1px solid ${C.line}` }}>
                <Typography
                  sx={{
                    fontFamily: FONT,
                    fontSize: "0.9375rem",
                    color: C.muted,
                    lineHeight: 1.75,
                  }}
                >
                  If you have a problem with your inquiry, please email <br />
                  {group !== "EXHIBITION" ? (
                    <a href="mailto:info@leon-gallery.com" style={contactLinkStyle}>
                      info@leon-gallery.com
                    </a>
                  ) : (
                    <a href="mailto:rinaformento@leon-gallery.com" style={contactLinkStyle}>
                      rinaformento@leon-gallery.com
                    </a>
                  )}
                  <br />
                  or call <span style={{ color: C.ink }}>(02) 8856-2781</span>
                </Typography>

                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 2.5 }}>
                  <Typography sx={{ ...labelSx, color: C.ink, mr: 1 }}>Follow us</Typography>

                  <IconButton
                    href="https://www.facebook.com/LeonGalleryMakati/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="León Gallery on Facebook"
                    size="small"
                    sx={socialSx}
                  >
                    <i className="fa fa-facebook-f" style={{ fontSize: "14px" }}></i>
                  </IconButton>

                  <IconButton
                    href="https://twitter.com/leongalleryph"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="León Gallery on X (Twitter)"
                    size="small"
                    sx={socialSx}
                  >
                    <i className="fa fa-twitter" style={{ fontSize: "14px" }}></i>
                  </IconButton>

                  <IconButton
                    href="mailto:info@leon-gallery.com"
                    aria-label="Email León Gallery"
                    size="small"
                    sx={socialSx}
                  >
                    <i className="fa fa-envelope-o" style={{ fontSize: "14px" }}></i>
                  </IconButton>

                  <IconButton
                    href="https://www.youtube.com/channel/UCcgsLbrD84mc26EuWzVptzA"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="León Gallery on YouTube"
                    size="small"
                    sx={socialSx}
                  >
                    <i className="fa fa-youtube-play" style={{ fontSize: "14px" }}></i>
                  </IconButton>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </div>

      {/* CATALOGUE DETAILS — full screen (phones) */}
      <Dialog
        fullScreen
        open={openDetailsModal}
        onClose={() => setOpenDetailsModal(false)}
        TransitionComponent={Transition}
        className="lg-private-lot"
      >
        <Box sx={{ position: "relative", bgcolor: "#fff", minHeight: "100vh" }}>
          <Box
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 2,
              bgcolor: "#fff",
              borderBottom: `1px solid ${C.line}`,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 2.5,
              py: 1.25,
            }}
          >
            <Typography sx={{ ...labelSx, color: C.ink }}>Lot Details</Typography>
            <IconButton
              onClick={() => setOpenDetailsModal(false)}
              aria-label="Close details"
              sx={{ color: C.ink, borderRadius: 0, mr: -1 }}
            >
              <CloseIcon sx={{ fontSize: "24px" }} />
            </IconButton>
          </Box>

          <Grid container justifyContent="center" sx={{ pt: 3, pb: 6, px: 2.5 }}>
            <Grid item xs={12} md={8}>
              <Typography
                component="div"
                sx={{ fontFamily: FONT, fontSize: "1.35rem", lineHeight: 1.2, color: C.ink }}
                dangerouslySetInnerHTML={{ __html: artist }}
              />
              <Typography
                component="div"
                sx={{ fontFamily: FONT, fontStyle: "italic", fontSize: "1.1rem", lineHeight: 1.35, color: "#444", mt: 0.5, mb: 3 }}
                dangerouslySetInnerHTML={{ __html: title }}
              />
              {renderDetailsContent()}
              <Box sx={{ textAlign: "center", mt: 5 }}>
                <Button
                  variant="outlined"
                  onClick={() => setOpenDetailsModal(false)}
                  sx={{
                    borderRadius: 0,
                    borderColor: C.ink,
                    color: C.ink,
                    px: 6,
                    py: 1.25,
                    fontFamily: FONT,
                    fontWeight: 400,
                    letterSpacing: "0.2em",
                    "&:hover": { borderColor: "#000", bgcolor: "transparent", opacity: 0.7 },
                  }}
                >
                  CLOSE
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Dialog>

      {/* ENQUIRY */}
      <Dialog
        open={open}
        onClose={handleClose}
        fullScreen={!isDesktop}
        className="lg-private-lot"
        PaperProps={{
          sx: { borderRadius: 0, maxWidth: 560, width: "100%", position: "relative", boxShadow: "0 12px 40px rgba(0,0,0,0.12)" },
        }}
      >
        <IconButton
          onClick={handleClose}
          aria-label="Close enquiry"
          sx={{ position: "absolute", right: 10, top: 10, color: C.ink, borderRadius: 0 }}
        >
          <CloseIcon sx={{ fontSize: "22px" }} />
        </IconButton>
        <form onSubmit={inquirehandle}>
          <DialogTitle
            sx={{
              textAlign: "center",
              pt: 5,
              pb: 1,
              fontFamily: FONT,
              fontWeight: 400,
              fontSize: "1.6rem",
              letterSpacing: "0.2em",
              color: C.ink,
            }}
          >
            ENQUIRY
          </DialogTitle>
          <DialogContent sx={{ px: { xs: 2.5, md: 5 }, pt: 1 }}>
            <DialogContentText
              sx={{ textAlign: "center", mb: 3, fontFamily: FONT, fontSize: "0.95rem", lineHeight: 1.7, color: C.muted }}
            >
              Contact one of our specialists. <br />{" "}
              <strong style={{ color: C.ink, fontWeight: 400 }}>info@leon-gallery.com</strong> will advise further.
            </DialogContentText>
            <Grid container columnSpacing={2} rowSpacing={1}>
              <Grid item xs={12} sm={6}>
                <Typography sx={fieldLabelSx}>FIRST NAME *</Typography>
                <TextField
                  fullWidth
                  required
                  size="small"
                  variant="outlined"
                  onChange={(e) => setFirstName(e.target.value)}
                  sx={sothebyInputStyleCompact}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={fieldLabelSx}>LAST NAME</Typography>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  onChange={(e) => setLastName(e.target.value)}
                  sx={sothebyInputStyleCompact}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography sx={fieldLabelSx}>PHONE NUMBER</Typography>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  onChange={(e) => setPhone(e.target.value)}
                  sx={sothebyInputStyleCompact}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography sx={fieldLabelSx}>EMAIL ADDRESS *</Typography>
                <TextField
                  fullWidth
                  required
                  size="small"
                  type="email"
                  variant="outlined"
                  onChange={(e) => setEmail(e.target.value)}
                  sx={sothebyInputStyleCompact}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography sx={fieldLabelSx}>MESSAGE *</Typography>
                <TextField
                  fullWidth
                  required
                  multiline
                  rows={4}
                  variant="outlined"
                  onChange={(e) => setMessage(e.target.value)}
                  sx={sothebyInputStyleCompact}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions sx={{ px: { xs: 2.5, md: 5 }, pb: 4, pt: 1 }}>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              disableElevation
              sx={{
                minHeight: 54,
                bgcolor: C.ink,
                color: "#fff",
                borderRadius: 0,
                fontFamily: FONT,
                fontSize: "0.875rem",
                fontWeight: 400,
                letterSpacing: "0.24em",
                boxShadow: "none",
                "&:hover": { bgcolor: "#000", boxShadow: "none" },
              }}
            >
              SUBMIT ENQUIRY
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <Backdrop sx={{ color: "#fff", zIndex: 9999 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={openNotif}
        autoHideDuration={6000}
        onClose={handleClosess}
        message={inquireMessage}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        className="lg-private-lot"
      />
    </Box>
    </>
  );
}

export default View;
